const banner = 'https://admanawards.com/newadmin/public/api/banners/get/'
const sponsor = 'https://admanawards.com/newadmin/public/api/sponsor'
const about = {
  committeeCategory: 'https://admanawards.com/newadmin/public/api/about/committee',
  committee: 'https://admanawards.com/newadmin/public/api/about/committee/',
  chairmanBiography: 'https://admanawards.com/newadmin/public/api/about/chairman'
}
const creativity = {
  program: 'https://admanawards.com/newadmin/public/api/creativeday/program',
  talkSymposium: 'https://admanawards.com/newadmin/public/api/creativeday/time/1',
  talkSymposiumDetail: 'https://admanawards.com/newadmin/public/api/creativeday/detail/',
  schoolCreativity: 'https://admanawards.com/newadmin/public/api/creativeday/room/2',
  schoolCreativityTime: 'https://admanawards.com/newadmin/public/api/creativeday/time/',
  schoolCreativityDetail: 'https://admanawards.com/newadmin/public/api/creativeday/detail/'
}

const news = {
  list: 'https://admanawards.com/newadmin/public/api/activity/list',
  detail: 'https://admanawards.com/newadmin/public/api/activity/'
}

const winners = 'https://admanawards.com/newadmin/public/api/winner'

const program = {
  category: 'https://admanawards.com/newadmin/public/api/archivevideocat',
  archive: 'https://admanawards.com/newadmin/public/api/archivevideo'
}

const gallery = {
  list: 'https://admanawards.com/newadmin/public/api/gallerycategory',
  year: 'https://admanawards.com/newadmin/public/api/galleryyear/',
  detail: 'https://admanawards.com/newadmin/public/api/gallery/'
}

const awards = {
  rules: 'https://admanawards.com/newadmin/public/api/awardrules',
  judge: {
    category: 'https://admanawards.com/newadmin/public/api/judgecategory',
    list: 'https://admanawards.com/newadmin/public/api/judge/'
  },
  categories: {
    link: 'https://admanawards.com/newadmin/public/api/award_link',
    list: 'https://admanawards.com/newadmin/public/api/award_category',
    detail: 'https://admanawards.com/newadmin/public/api/award/'
  }
}

const archive = {
  category: 'https://admanawards.com/newadmin/public/api/archive_category',
  subCategory: 'https://admanawards.com/newadmin/public/api/archive_subcategory/',
  content: 'https://admanawards.com/newadmin/public/api/archive/'
}

export default {
  banner,
  sponsor,
  about,
  creativity,
  news,
  winners,
  program,
  gallery,
  awards,
  archive
}
